export default __webpack_public_path__ + "static/media/minusButton.8c562f9d.svg";